import {ServiceClass} from '@/decorators';

@ServiceClass()
export class SelectedSiteService {
    public name: string = 'save-location-dialog';
    public selectedSite: string | null = null;
    public stepNumber: any = 2;
}
